import React from 'react';
import SEO from './seo';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'black',
  },
}));

type LayoutProps = { children: React.ReactNode; className?: string };

const Layout = (props: LayoutProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <SEO title="WFP - EU 2019 Partnership Report" />

      <main className={classes.root}>
        <div>{props.children}</div>
      </main>
    </div>
  );
};

export default Layout;
